module.exports = __webpack_public_path__ + "media/images/new-ui-images/backto-d3bdac5ad56eceb593817eb397cd3365.svg";